import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import MenuItem from 'components/atoms/MenuItem';
import menuItems from 'common/menu_items';
import routeCodes from 'common/constants/route-codes';
import { useCommon } from 'redux/common/use-common';
import { useSettingsStepContext } from 'context/SettingsStepContext';
import { useUser } from 'redux/user/use-user';
import {
  Wrapper,
  List,
  ModalContent,
  ModalDescription,
  ModalList,
} from './styled';
import { PrimaryModal } from 'components/molecules/Modal';

const MobileMenu = ({ open, updateMenuStep, onClose }) => {
  const [showAdvancedModal, setShowAdvancedModal] = useState(false);
  const { pathname } = useLocation();
  const { isSuperAdmin } = useUser();
  const { handleGetStripeLink } = useCommon();
  const { resetStep: resetSettingsStep } = useSettingsStepContext();

  useEffect(() => {
    onClose?.();
  }, [pathname, onClose]);

  const handleOpenAdvancedModal = () => {
    onClose?.();
    setShowAdvancedModal(true);
  };
  const handleCloseAdvancedModal = () => setShowAdvancedModal(false);

  const withClose = useCallback(
    (handler) => {
      return (...args) => {
        onClose?.();
        if (typeof handler === 'function') {
          return handler(...args);
        }
      };
    },
    [onClose],
  );

  const getOnClick = (item) => {
    if (item.onClick === 'handleOpenAdvancedModal') {
      return handleOpenAdvancedModal;
    }
    if (typeof item.onClick === 'function') {
      return withClose(item.onClick);
    }
    // Stripe (and similar) items have no href and rely on the shared handler
    if (!item.href) {
      return withClose(handleGetStripeLink);
    }
    return withClose();
  };

  const getMainItemOnClick = (item) =>
    withClose(() => {
      if (item.onClick === 'menuStep') {
        updateMenuStep('start');
      }
      if (item.href === routeCodes.settings) {
        resetSettingsStep();
      }
    });

  return (
    <>
      <Wrapper open={open}>
        {isSuperAdmin ? (
          <>
            <List desktop_mb={60}>
              {menuItems.superAdmin.main.map((i) => (
                <MenuItem
                  key={i.label}
                  {...i}
                  active={
                    i.href === '/'
                      ? pathname === '/'
                      : pathname.includes(i.href)
                  }
                  onClick={getOnClick(i)}
                />
              ))}
            </List>
            <List footer={true}>
              {menuItems.superAdmin.footer.map((i) => (
                <MenuItem
                  key={i.label}
                  {...i}
                  active={pathname.includes(i.href)}
                  onClick={getOnClick(i)}
                />
              ))}
            </List>
          </>
        ) : (
          <>
            <List>
              {menuItems.main.map((i) => (
                <MenuItem
                  key={i.label}
                  {...i}
                  active={
                    i.href === '/'
                      ? pathname === '/'
                      : pathname.includes(i.href)
                  }
                  onClick={getMainItemOnClick(i)}
                />
              ))}
            </List>
            <List footer={true}>
              {menuItems.footer.map((i) => (
                <MenuItem
                  key={i.label}
                  {...i}
                  active={i.href ? pathname.includes(i.href) : false}
                  clickable={i.href === undefined && true}
                  onClick={getOnClick(i)}
                  isFooter={true}
                />
              ))}
            </List>
          </>
        )}
      </Wrapper>

      <PrimaryModal
        showDivider
        open={showAdvancedModal}
        desktopW='760'
        onClose={handleCloseAdvancedModal}
        onCancel={handleCloseAdvancedModal}
        title='Passa a Gestione avanzata'
        hideFooter={true}
      >
        <ModalContent>
          <ModalDescription>Passa alla gestione avanzata per:</ModalDescription>
          <ModalList>
            <li>Attivare i servizi di delivery e asporto</li>
            <li>Buoni VisitBergamo restaurant</li>
            <li>Offerte</li>
            <li>Generare QR code</li>
            <li>Stripe</li>
            <li>Ipratico</li>
          </ModalList>
        </ModalContent>
      </PrimaryModal>
    </>
  );
};

MobileMenu.propTypes = {
  open: PropTypes.bool,
  updateMenuStep: PropTypes.func,
  onClose: PropTypes.func,
};

export default MobileMenu;
